import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=3bb8fd52"
import script from "./Shipping.vue?vue&type=script&lang=ts"
export * from "./Shipping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports